import {Button, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useUniversalTracking} from '../../lib/tracking/universalTracking';
import {ContinueButton} from '../ContinueButton/ContinueButton';
import {ChevronLeft} from '@material-ui/icons';
import {KehButton} from "../../types/redux";
import Loading from "../Loading/Loading";

interface Props extends StateProps, DispatchProps {
	onClickContinue(): void;
}

const useStyles = makeStyles((theme: Theme) => ({
	bottomPlaceholder: {
		marginBottom: 100,
	},
	navigationBarMain: {
		position: 'fixed',
		bottom: '0px',
		left: '0px',
		height: '70px',
		boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
		width: '100vw',
		display: 'flex',
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		alignItems: 'center',
		paddingLeft: '5vw',
		paddingRight: '5vw',
		backgroundColor: 'white',
		zIndex: theme.zIndex.appBar,
	},
	sectionTitle: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(2),
		paddingRight: "300px"
	},
}));

const NavigationBar: React.FC<Props> = (props) => {
	const { trackEvent } = useUniversalTracking();
	const { t } = useTranslation();
	const classes = useStyles();

	useEffect(() => {
		checkIsStepperMobileModalDisplayed();
	});

	const [isStepperMobileModalDisplayed, setIsStepperMobileModalDisplayed] =
		useState(false);

	// todo: check functionality, seems to be not a reactive way to check if an element is displayed
	const checkIsStepperMobileModalDisplayed = () => {
		const elem = document.getElementsByClassName(
			'contract_wizard_mobile_stepper_modal'
		);
		setIsStepperMobileModalDisplayed(Boolean(elem.length > 0));
	};

	// TODO: add info about contract type, current form
	const handleClickBackButton = () => {
		trackEvent({
			category: 'contract-wizard-previous-form',
			action: 'click-event',
			label: 'contract-wizard',
		});
		props.goPreviousForm();
	};

	const [btnText, setBtnText] = useState('common.continue');

	useEffect(() => {
		let selBtn = props.selectedButton
		if( props.showPrice ) selBtn=KehButton.NOT_SELECTED;
		switch(selBtn){
			case KehButton.CALC_NOW:
				setBtnText('common.calc');
				break
			case KehButton.FINISH_NOW:
				setBtnText('common.finish');
				break
			default:
				setBtnText('common.continue')
		}
	}, [props.showPrice, props.selectedButton]);

	return (
		<>
			<div className={classes.bottomPlaceholder} />
			{!isStepperMobileModalDisplayed && (
				<div className={classes.navigationBarMain} >
					{props.isLoading && <Loading showSpinner={true} isTopView={true} />}
					{props.showPrice && <Typography  variant="h3" className={classes.sectionTitle}>{props.price}</Typography> }
					<div style={{ width: 250, position: "absolute" }}>
						<ContinueButton onClick={props.onClickContinue}>
							{t(btnText)}
						</ContinueButton>
					</div>
				{props.currentForm > 0 && props.currentForm !== props.forms.length && (
					<div style={{left: "5vw", position: "absolute"}}>
						<Button onClick={handleClickBackButton} startIcon={<ChevronLeft />} >
							{t('common.back')}
						</Button>
					</div>
				)}
				</div>
			)}
		</>
	);
};

interface DispatchProps {
}

interface StateProps {
	forms: string[];
	currentForm: number;
	currentStep: number;
	isLoading: boolean;
	selectedButton: KehButton;
	showPrice?: boolean;
	price?: string;
}

interface DispatchProps {
	goPreviousForm(): void;
}

export default NavigationBar;
